module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../node_modules/babel-loader/lib/index.js??ref--0-0!./root.jsx"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./components/root.jsx
// module id = 684
// module chunks = 27